import { FC } from 'react';
import AcceptPeriodAdjustment from './AcceptPeriodAdjustment';
import UseAcceptPeriodAdjustment from './UseAcceptPeriodAdjustment';

const AcceptPeriodAdjustmentContainer: FC = () => {
  return <AcceptPeriodAdjustment {...UseAcceptPeriodAdjustment()} />;
};

export default AcceptPeriodAdjustmentContainer;
